import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import {NoMatch} from "../../components";

export default ({ session: session, component: Component, ...rest }) => {
    if(rest.computedMatch.params.code) {
        localStorage.setItem('invite_code', rest.computedMatch.params.code);
    }

    if(!session.isLoggedIn){
        return <Redirect from="/invite" to={`/signin/${rest.computedMatch.params.code}`} />;
    }

    return(
        <Route {...rest} render={props => (<Component {...props}/>)}/>
    ) 
}


// WEBPACK FOOTER //
// ./src/components/Commons/InvatePrivateRoute.js